export default "__VITE_ASSET__BMMOlagG__"